import {
  StudentAddingBundleInterface,
  StudentAddingCourseInterface,
  StudentExportLogInterface,
} from 'modules/courses/students/types/student-interface'
import httpClient from 'shared/utils/http-client'

export const STUDENTS_API = '/api/dashboard/customer/membership/students'
export const STUDENTS_API_NEW = '/api/membership/secure/label/students'
export const STUDENT_PROGRESS_EXPORT_API = '/api/membership/secure/label/student-export'

export const addCourse = (id: number, data: StudentAddingCourseInterface) =>
  httpClient.post(`${STUDENTS_API}/${id}/add-course`, data)

export const addBundle = (id: number, data: StudentAddingBundleInterface) =>
  httpClient.post(`${STUDENTS_API}/${id}/add-bundle`, data)

export const exportStudentCourseSessionLog = (
  studentId: string,
  courseId: number,
  data: StudentExportLogInterface,
) =>
  httpClient.post<ArrayBuffer>(
    `${STUDENTS_API}/${studentId}/${courseId}/course-session-log/export`,
    data,
    {
      responseType: 'blob',
    },
  )

export const exportStudentCourseBundleSessionLog = (
  studentId: string,
  courseBundleId: number,
  data: StudentExportLogInterface,
) =>
  httpClient.post<ArrayBuffer>(
    `${STUDENTS_API}/${studentId}/${courseBundleId}/course-bundle-session-log/export`,
    data,
    {
      responseType: 'blob',
    },
  )

export const sendWelcomeEmail = (studentId: number, enrollmentId: number) =>
  httpClient.post(`${STUDENTS_API}/${studentId}/enrollment/${enrollmentId}/welcome-email`)

export const reactivateEnrollment = (studentId: number, enrollmentId: number) =>
  httpClient.post(`${STUDENTS_API}/${studentId}/enrollment/${enrollmentId}/reactivate`)

export const dismissEnrollment = (studentId: number, enrollmentId: number) =>
  httpClient.post(`${STUDENTS_API}/${studentId}/enrollment/${enrollmentId}/dismiss`)

export const resetProgress = (studentId: number, courseId: number) =>
  httpClient.post(`${STUDENTS_API_NEW}/${studentId}/reset-progress/${courseId}`)

export const getStudentProgressExportStatusPath = (id: number) =>
  `${STUDENT_PROGRESS_EXPORT_API}/${id}`

export const getCancelStudentProgressExportPath = (id: number) =>
  `${STUDENT_PROGRESS_EXPORT_API}/cancel/${id}`

export const removeStudent = (id: number) => httpClient.delete(`${STUDENTS_API}/${id}`)

export const getLectureAccessDates = (enrollmentId: number) =>
  `${STUDENTS_API}/enrollments/${enrollmentId}/list`
